import React from "react";
import Window from "./Window";
import DynamicValue from "../DynamicValue";

import "./GameLimits.css";
import Common from "../Common";

export default class GameLimits extends React.Component<GameLimits.Props, GameLimits.State>
{


    constructor(props: GameLimits.Props)
    {
        super(props)
    }


    render()
    {
        const lang = window.lang.shared.modals["game-limits"];
        const lShared = window.lang.shared;

        return (
            <Window
                id="gameLimits"
                title={lShared.game_limits}
            >
                <div className="container">
                    <div className="item">
                        <div className="title">
                            {lang["min-bet"]}({currency}):
                        </div>
                        <div className="value">
                            <DynamicValue
                                id="min_bet"
                                ignoreDecimals={true}
                            />
                        </div>
                    </div>

                    <div className="item">
                        <div className="title">
                            {lang["max-bet"]}({currency}):
                        </div>
                        <div className="value">
                            <DynamicValue
                                id="max_bet"
                                ignoreDecimals={true}
                            />
                        </div>
                    </div>

                    <div className="item">
                        <div className="title">
                            {lang["max-win-one-bet"]}({currency}):
                        </div>
                        <div className="value">
                            <DynamicValue
                                id="max_win"
                                ignoreDecimals={true}
                            />
                        </div>
                    </div>
                </div>
            </Window>
        )
    }


    getCurrency()
    {
        return " " + global.currency;
    }


}


export namespace GameLimits
{


    export interface Props
    {

    }


    export interface State
    {

    }


}